import MigrationListPage from "./MigrationListPage";
export default function MigrationVisitedPage() {
  return <MigrationListPage stage="visited_called" title="Completed/Visited/Called" />;
}
